function isEditableTarget(target) {
  if (!target) return false;

  const tag = target.tagName;
  return (
    target.isContentEditable ||
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT"
  );
}

function visibleItems(items) {
  return items.filter((item) => !item.hidden);
}

function setActive(items, index) {
  items.forEach((item) => item.classList.remove("is-active"));

  const next = items[index];
  if (!next) return;

  next.classList.add("is-active");
  next.scrollIntoView({ block: "nearest" });
}

function setupAdminSidebarCollapse() {
  const shell = document.querySelector("[data-admin-shell]");
  const toggle = document.querySelector("[data-admin-sidebar-toggle]");
  if (!shell || !toggle || shell.dataset.sidebarInitialized === "true") return;

  shell.dataset.sidebarInitialized = "true";

  const storageKey = "industry-watch:admin-sidebar-collapsed";

  const applyState = (collapsed) => {
    const label = collapsed
      ? "Expand admin navigation"
      : "Collapse admin navigation";

    shell.classList.toggle("is-sidebar-collapsed", collapsed);
    toggle.setAttribute("aria-pressed", collapsed ? "true" : "false");
    toggle.setAttribute("aria-label", label);
    toggle.setAttribute("title", label);
  };

  applyState(window.localStorage.getItem(storageKey) === "true");

  toggle.addEventListener("click", () => {
    const collapsed = !shell.classList.contains("is-sidebar-collapsed");
    window.localStorage.setItem(storageKey, collapsed ? "true" : "false");
    applyState(collapsed);
  });
}

export function setupAdminCommandPalette() {
  setupAdminSidebarCollapse();

  const palette = document.querySelector("[data-admin-command-palette]");
  if (!palette || palette.dataset.initialized === "true") return;

  palette.dataset.initialized = "true";

  const input = palette.querySelector("[data-admin-command-input]");
  const items = Array.from(
    palette.querySelectorAll("[data-admin-command-item]"),
  );
  const groups = Array.from(
    palette.querySelectorAll("[data-admin-command-group]"),
  );
  const empty = palette.querySelector("[data-admin-command-empty]");
  const openers = Array.from(
    document.querySelectorAll("[data-admin-command-open]"),
  );
  const closers = Array.from(
    palette.querySelectorAll("[data-admin-command-close]"),
  );

  let activeIndex = 0;

  const filterItems = () => {
    const query = input.value.trim().toLowerCase();

    items.forEach((item) => {
      const label = item.dataset.adminCommandLabel.toLowerCase();
      item.hidden = query !== "" && !label.includes(query);
    });

    groups.forEach((group) => {
      const groupItems = Array.from(
        group.querySelectorAll("[data-admin-command-item]"),
      );
      group.hidden = groupItems.every((item) => item.hidden);
    });

    const current = visibleItems(items);
    activeIndex = 0;
    setActive(current, activeIndex);
    empty.hidden = current.length !== 0;
  };

  const open = () => {
    palette.hidden = false;
    input.value = "";
    filterItems();
    window.setTimeout(() => input.focus(), 0);
  };

  const close = () => {
    palette.hidden = true;
    input.value = "";
    items.forEach((item) => item.classList.remove("is-active"));
  };

  openers.forEach((opener) => opener.addEventListener("click", open));
  closers.forEach((closer) => closer.addEventListener("click", close));
  input.addEventListener("input", filterItems);

  palette.addEventListener("keydown", (event) => {
    const current = visibleItems(items);

    if (event.key === "Escape") {
      event.preventDefault();
      close();
      return;
    }

    if (event.key === "ArrowDown") {
      event.preventDefault();
      activeIndex = Math.min(activeIndex + 1, current.length - 1);
      setActive(current, activeIndex);
      return;
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      activeIndex = Math.max(activeIndex - 1, 0);
      setActive(current, activeIndex);
      return;
    }

    if (event.key === "Enter" && current[activeIndex]) {
      event.preventDefault();
      current[activeIndex].click();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (isEditableTarget(event.target) && event.target !== input) return;

    const key = event.key.toLowerCase();
    const modifierOpen = (event.metaKey || event.ctrlKey) && key === "k";

    if (modifierOpen || (key === "/" && palette.hidden)) {
      event.preventDefault();
      open();
      return;
    }

    if (event.key === "Escape" && !palette.hidden) {
      event.preventDefault();
      close();
      return;
    }

    if (!palette.hidden || event.metaKey || event.ctrlKey || !event.altKey)
      return;

    const shortcut = items.find(
      (item) => (item.dataset.adminShortcut || "").toLowerCase() === key,
    );

    if (shortcut) {
      event.preventDefault();
      window.location.href = shortcut.href;
    }
  });
}
